/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Assign_Track_AInputs */



/**
* | output |
* | --- |
* | "Assign Track A" |
*
* @param {Shortcut_Keys_Name_Assign_Track_AInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_assign_track_a = /** @type {((inputs?: Shortcut_Keys_Name_Assign_Track_AInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Assign_Track_AInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Attribuer la piste A")
	if (locale === "de") return /** @type {LocalizedString} */ ("Spur A zuweisen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Assegna la traccia A")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Назначить дорожку A")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asignar pista A")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分配轨道 A")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トラックAを割り当てる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रैक A असाइन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atribuir faixa A")
	return /** @type {LocalizedString} */ ("Assign Track A")
});